import base from './base';
import palette from './palette';

const link = {
  MuiLink: {
    styleOverrides: {
      root: {
        '&:hover': {
          color: palette.primary.light,
          // textDecoration: 'underline',
        },

        '&:focus-visible': {
          outline: '2px solid',
          outlineColor: palette.primary.dark,
          outlineOffset: 2,
          borderRadius: base.shape.borderRadius,
          color: palette.primary.dark,
        },
      },
    },
  },
};

export default link;
